import { z } from 'zod'

const viewRefresherAction = z.object({
  action: z.literal('view_refresher'),
})

const dismissAction = z.object({
  action: z.literal('dismiss'),
})

const refresherFeedbackAction = z.object({
  action: z.literal('refresher_feedback'),
})

export const recallActionSchema = z.discriminatedUnion('action', [
  viewRefresherAction,
  dismissAction,
  refresherFeedbackAction,
])

export type RecallActionInput = z.infer<typeof recallActionSchema>
